export const routes = {
  HOME: "/",
  INITIAL_ONBOARDING: "/start",
  COMPARE: "/compare",
  PREFERENCES: "/preferences",
  SUPPORT: "/support",
  SIGNIN: "/signin",
  SIGNUP: "/signup",
  AUTH_WELCOME: "/auth/welcome",
  AUTH_FORGOT_PASSWORD: "/auth/forgot-password",
  AUTH_HANDLE_PASSWORD_RESET: "/auth/handle-password-reset",
  TOP_3_STUDIES: "/top-3",
  FAVORITES: "/favorites",
  MY_PROFILE: "/my-profile",
  ASSESSMENTS: {
    ROOT: "/assessments",
    PERSONALITY: "/assessments/personality",
    INTERESTS: "/assessments/interests",
    TALENTS: "/assessments/talents",
  },
  CONSUMER: {
    PAYMENT_SUCCESS: "/payment/success",
    CREATE_ACCOUNT: "/payment/create-account",
  },
  BONUSSEN: "/bonussen",
} as const;

export type RouteKey = keyof typeof routes;
export type AssessmentRouteKey = keyof typeof routes.ASSESSMENTS;